import {TrainHistoryEntry} from '../common/train';
import {TrainFidelity} from '../common/train-fidelity';
import {_} from '../../../shared/utils';
import {TranslateService} from '@ngx-translate/core';

export function parseTrainHistory(trains: TrainHistoryEntry[], translate: TranslateService) {
  let longDistanceCount = 0, longDistanceSum = 0;
  let commuterCount = 0, commuterSum = 0;
  let freightCount = 0, freightSum = 0;

  const causes = new Map<string, number>();

  for (const train of trains) {
    if (train.type === 'OTHER' || train.state !== 'RUNNING') {
      continue;
    }
    if (train.type === 'LONGDISTANCE' && train.calculatedDelta < 6) {
      longDistanceSum++;
    } else if (train.type === 'COMMUTER' && train.calculatedDelta < 3) {
      commuterSum++;
    } else if (train.type === 'FREIGHT' && train.calculatedDelta < 15) {
      freightSum++;
    }
    if (train.type === 'LONGDISTANCE') {
      longDistanceCount++;
    } else if (train.type === 'COMMUTER') {
      commuterCount++;
    } else if (train.type === 'FREIGHT') {
      freightCount++;
    }

    train.timetable.forEach(row => {
      let code = null;
      if (row.causes.thirdCategoryCode) {
        code = row.causes.thirdCategoryCode;
      } else if (row.causes.detailedCategoryCode) {
        code = row.causes.detailedCategoryCode;
      } else if (row.causes.categoryCode) {
        code = row.causes.categoryCode;
      }
      if (causes.has(code)) {
        causes.set(code, causes.get(code) + 1);
      } else {
        // console.log(train);
        causes.set(code, 1);
      }
    });
  }

  const fidelity: TrainFidelity[] = [
    {
      value: Math.round(longDistanceSum / longDistanceCount * 100),
      sum: longDistanceSum,
      count: longDistanceCount,
      id: 'LONGDISTANCE'
    },
    {
      value: Math.round(commuterSum / commuterCount * 100),
      sum: commuterSum,
      count: commuterCount,
      id: 'COMMUTER'
    },
    {
      value: Math.round(freightSum / freightCount * 100),
      sum: freightSum,
      count: freightCount,
      id: 'FREIGHT'
    }
  ];
  return {fidelity: fidelity, causes: causes};
}
